<ng-container *transloco="let t; read: 'contact'" >
  <h1 class="pbm">{{ t('title') }}</h1>

  <form
    [formGroup]="filterForm"
    (submit)="onSubmit()"
    (reset)="onReset()"
    class="flex flexDirRow vertical-bottom"
    >
    <kendo-label [text]="t('searchString')">
      <kendo-textbox
          formControlName="keyword"
      ></kendo-textbox>
  </kendo-label>

  <div>
    <button
      kendoButton
      fillMode="solid"
      size="medium"
      rounded="medium"
      themeColor="primary"
      type="submit"
      class="mrs mls"
      [disabled]="!filterForm.dirty || !filterForm.get('keyword').value"
      loadingIndication="/contact/searchcontacts"
    >
      {{t('submit')}}
    </button>
    <button
      kendoButton
      fillMode="outline"
      size="medium"
      rounded="medium"
      themeColor="primary"
      type="reset"
      *ngIf="showResetButton"
      loadingIndication="/contact/searchcontacts"

    >
      {{t('reset')}}
    </button>
  </div>

  </form>

  <kendo-grid
    [data]="contacts"
    [skip]="gridState.skip"
    [pageSize]="gridState.pageSize"
    [pageable]="true"
    (pageChange)="onPageChange($event)"
    scrollable="none"
    class="mtm"
  >
    <ng-template kendoGridToolbarTemplate>
      <button
        *permissionIf="'Permissions.Contacts.Create'"
        kendoButton
        [routerLink]="['/contact']"
        fillMode="solid"
        size="medium"
        rounded="medium"
        themeColor="primary"
      >
        {{ t('newContact') }}
      </button>
    </ng-template>
    <kendo-grid-column field="fullName" [title]="t('name')" media="(min-width: 450px)"></kendo-grid-column>
    <kendo-grid-column field="externalNumber" [title]="t('externalNumber')" media="(min-width: 450px)"></kendo-grid-column>

    <kendo-grid-column field="phone" [title]="t('phone')" media="(min-width: 450px)"></kendo-grid-column>
    <kendo-grid-column field="email" [title]="t('email')" media="(min-width: 450px)"></kendo-grid-column>
    <kendo-grid-column [title]="t('action')" media="(min-width: 450px)">
      <ng-template kendoGridCellTemplate let-dataItem>
          <button
              kendoButton
              [routerLink]="['/contact', dataItem.id]"
          >{{ t('detail') }}</button>
      </ng-template>
    </kendo-grid-column>

  <!-- Mobile View -->
  <kendo-grid-column media="(max-width: 450px)" [title]="t('entries')">
    <ng-template kendoGridCellTemplate let-dataItem>

      <ng-container *ngIf="dataItem.isCompany">
        <h4>
          {{dataItem.companyName}}
        </h4>
      </ng-container>
      <ng-container *ngIf="!dataItem.isCompany">
        <h4>
          {{t('salutations.' + Salutations[dataItem.salutation]) + " " + dataItem.firstName + " " + dataItem.lastName }}
        </h4>
      </ng-container>


      <dl>
        <ng-container *ngIf="dataItem.phone">
          <dt>{{ t('phone') }}</dt>
          <dd>
            {{dataItem.phone}}
          </dd>
        </ng-container>


        <ng-container *ngIf="dataItem.email">
          <dt>{{ t('email') }}</dt>
          <dd>
            {{dataItem.email}}
          </dd>
        </ng-container>


        <dd>
          <button
              kendoButton
              [routerLink]="['/contact', dataItem.id]"
              class="mts"
          >{{ t('detail') }}</button>
        </dd>

      </dl>
    </ng-template>
  </kendo-grid-column>


    <ng-template
      let-totalPages="totalPages"
      let-currentPage="currentPage"
      kendoPagerTemplate
    >
      <div class="flex flexDirRow">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons
          [buttonCount]="5"
        ></kendo-pager-numeric-buttons>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
      </div>
      <div>
        <label for="pageBtnGroup" class="mrs">{{ t('resultsPerPage') }}</label>
        <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
          <button
            (click)="onPageSizeChange(pageSizes.Small)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Small"
            [toggleable]="true"
          >
            {{ pageSizes.Small }}
          </button>
          <button
            (click)="onPageSizeChange(pageSizes.Medium)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Medium"
            [toggleable]="true"
          >
            {{ pageSizes.Medium }}
          </button>
          <button
            (click)="onPageSizeChange(pageSizes.Large)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Large"
            [toggleable]="true"
          >
            {{ pageSizes.Large }}
          </button>
        </kendo-buttongroup>

        <button
          kendoButton
          [title]="t('refresh')"
          (click)="onGridReload()"
          icon="reload"
        ></button>
      </div>
    </ng-template>
    <ng-template kendoGridNoRecordsTemplate>
      <div class="text pl">{{ t('noResults') }}</div>
    </ng-template>
  </kendo-grid>

</ng-container>
